import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
export function template() {
  const content = this.innerHTML.trim();
  return /* @__PURE__ */ jsx(ButtonEl, { attrs: this.helpers.getButtonAttrs(), on: {
    click: this.helpers.handleButtonClick
  }, "data-sentry-element": "ButtonEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, content ? /* @__PURE__ */ jsx("slot", null) : null);
}
